/**
 * @generated SignedSource<<8c613c6331d1213d895d2ab05e376bd7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useProfilePhotos_profile$data = {
  readonly id: string;
  readonly profilePhotos: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly cursor: any | null | undefined;
      readonly node: {
        readonly description: string | null | undefined;
        readonly rowId: any;
        readonly sequence: number;
        readonly storageObject: {
          readonly blurhash: string | null | undefined;
          readonly bucket: string | null | undefined;
          readonly key: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly " $fragmentType": "useProfilePhotos_profile";
};
export type useProfilePhotos_profile$key = {
  readonly " $data"?: useProfilePhotos_profile$data;
  readonly " $fragmentSpreads": FragmentRefs<"useProfilePhotos_profile">;
};

import UseProfilePhotosQuery_graphql from './UseProfilePhotosQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "profilePhotos"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UseProfilePhotosQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "useProfilePhotos_profile",
  "selections": [
    {
      "alias": "profilePhotos",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "type": {
              "equalTo": "PROFILE"
            }
          }
        }
      ],
      "concreteType": "PhotoConnection",
      "kind": "LinkedField",
      "name": "__useProfilePhotos_profile_profilePhotos_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotoEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Photo",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sequence",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StorageObject",
                  "kind": "LinkedField",
                  "name": "storageObject",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "blurhash",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "bucket",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "key",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": "__useProfilePhotos_profile_profilePhotos_connection(filter:{\"type\":{\"equalTo\":\"PROFILE\"}})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Profile",
  "abstractKey": null
};
})();

(node as any).hash = "c3a2e89475ab02d82b73a6bfbe46e282";

export default node;
